module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("学习建议")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄档"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择年龄档"
    },
    model: {
      value: (_vm.queryParam.ageBand),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "ageBand", $$v)
      },
      expression: "queryParam.ageBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW（3-5）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID（6-8）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH（9+）")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择技能"
    },
    model: {
      value: (_vm.queryParam.skill),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "skill", $$v)
      },
      expression: "queryParam.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Speaking"
    }
  }, [_vm._v("口语 Speaking")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分数档"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择分数档"
    },
    model: {
      value: (_vm.queryParam.scoreBand),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "scoreBand", $$v)
      },
      expression: "queryParam.scoreBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/advice/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.form.id ? '编辑学习建议' : '新建学习建议',
      "width": "760"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 90
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄档"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.ageBand),
      callback: function($$v) {
        _vm.$set(_vm.form, "ageBand", $$v)
      },
      expression: "form.ageBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW（3-5）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID（6-8）")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH（9+）")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Speaking"
    }
  }, [_vm._v("口语 Speaking")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "分数档"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.scoreBand),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreBand", $$v)
      },
      expression: "form.scoreBand"
    }
  }, [_c('Option', {
    attrs: {
      "value": "LOW"
    }
  }, [_vm._v("低档 LOW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "MID"
    }
  }, [_vm._v("中档 MID")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "HIGH"
    }
  }, [_vm._v("高档 HIGH")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")])], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "文案"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6,
      "placeholder": "给该年龄档、技能、分数档的学习建议正文"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e49cbd4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexAdviceList.vue
// module id = 1804
// module chunks = 8